// The three search modes of the GlobalSearchModal. Shared by the modal and its footer so the
// footer can render per-tab summaries without a circular import back into GlobalSearchModal.
export enum Tabs {
	BY_NAME = "BY_NAME",
	BY_FILTERS = "BY_FILTERS",
	BY_URL = "BY_URL",
}
